import { render, staticRenderFns } from "./CardUpload.vue?vue&type=template&id=19df3723&scoped=true&"
import script from "./CardUpload.vue?vue&type=script&lang=js&"
export * from "./CardUpload.vue?vue&type=script&lang=js&"
import style0 from "./CardUpload.vue?vue&type=style&index=0&id=19df3723&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19df3723",
  null
  
)

export default component.exports